export const questionTypes =
{
    PARAGRAPH: "PARAGRAPH",
    LINEAR_SCALE: "LINEAR_SCALE",
    RANGE: "RANGE",
    CHECKBOX: "CHECKBOX",
    RADIO: "RADIO",
    UPLOAD: "UPLOAD",
}